import {
    useEffect,
    type FC
} from "react";
import type {
    ItemPartContentProps,
    IItemTitleProps
} from "../../type";
import {
    getCardChildrenText,
    getCardHiddenProps
} from "../../../card/util";
import {
    ROW_CARD_TITLE_SKELETON_WIDTH
} from "../../../rowCard/stylesheet";
import {
    withItemContext
} from "../../context";
import Skeleton from "../../../skeleton";
import Text from "../../../text";

const ItemTitleBase: FC<ItemPartContentProps<IItemTitleProps>> = ({
    customTheme: customThemeProp,
    numberOfLines = 1,
    children,
    context,
    ...props
}) => {
    const customTheme = customThemeProp ?? context.customTheme;

    const {
        registerPart,
        isLoading
    } = context;

    const text = getCardChildrenText(children);

    const hiddenProps = getCardHiddenProps({
        isPressable: context.isPressable,
        text
    });

    useEffect(() => {
        if(isLoading) {
            return;
        }

        return registerPart("title", text);
    }, [
        registerPart,
        isLoading,
        text
    ]);

    if(isLoading) {
        return <Skeleton
            width={ROW_CARD_TITLE_SKELETON_WIDTH}
            typography={context.titleVariant}
            customTheme={customTheme}
            variant="text"
        />;
    }

    return <Text
        {...hiddenProps}
        {...props}
        customColor={context.titleColor}
        variant={context.titleVariant}
        numberOfLines={numberOfLines}
        customTheme={customTheme}
        id={context.titleID}
    >
        {children}
    </Text>;
};
export default withItemContext("title", ItemTitleBase);
